// App.jsx
import React from 'react';
//import { useState, useEffect } from 'react'; // old hooks
import { useState } from 'react'; // old hooks
// import Home from './components/Home';
// import Web from './components/Web';
// import Schedule from './components/Schedule';
// import PdfViewer from './components/PdfViewer';
import BottomNav from './components/BottomNav';

import MapView from './components/MapView';
import './App.css';

/* ============================
   PASSWORD GATE — DISABLED
============================ */
/*
const PASSWORD = "";
function PasswordGate({ onUnlock }) {
  ...
}
*/

function App() {
   const [value, setValue] = useState('map');
  // const [accessGranted, setAccessGranted] = useState(false);

  return (
    <div className="app-wrapper">
      <div className="app-container">
        <div className="content">
          <MapView />
        </div>
      </div>
      <BottomNav value={value} onChange={(event, newValue) => setValue(newValue)} />
    </div>
  );
}

export default App;
